<div id="rename-folder-dialog-container">
    <div id="rename-folder-dialog-title-container">
        <H2 matTooltip="{{ 'dialog.rename-folder.label.title' | translate: { folderName: folder.name }  }}">
            {{ 'dialog.rename-folder.label.title' | translate: { folderName: folder.name } }}
        </H2>
        <button id="close-dialog-button" mat-icon-button (click)="closeDialog()"
            matTooltip="{{ 'general.tooltip.close-dialog' | translate }}" color="warn">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <div id="rename-folder-dialog-content">
        <div id="rename-folder-dialog-language-container">
            <div class="language-selector" [ngClass]="[!selectedLanguage ? 'selected-language': '']"
                (click)="selectLanguage(null)"
                matTooltip="{{ 'dialog.rename-folder.tooltip.edit-base-info' | translate }}">
                <img src="assets/svg/flags/082-united-nations.svg">
            </div>
            <div class="language-selector" [ngClass]="[selectedLanguage == 'it' ? 'selected-language': '']"
                (click)="selectLanguage('it')"
                matTooltip="{{ 'dialog.rename-folder.tooltip.edit-it-info' | translate }}">
                <img src="assets/svg/flags/013-italy.svg">
            </div>
            <div class="language-selector" [ngClass]="[selectedLanguage == 'en' ? 'selected-language': '']"
                (click)="selectLanguage('en')"
                matTooltip="{{ 'dialog.rename-folder.tooltip.edit-en-info' | translate }}">
                <img src="assets/svg/flags/260-united-kingdom.svg">
            </div>
        </div>
        <div id="rename-folder-dialog-form-container">
            <div *ngIf="selectedLanguage && !folder.translations.get(selectedLanguage) && !creatingNew">
                <button mat-button color="primary" (click)="createNewTranslation()">
                    {{ 'dialog.rename-folder.button.add-translation' | translate }}
                </button>
            </div>


            <form id="rename-folder-dialog-form" [formGroup]="form" (submit)="submit()"
                *ngIf="!selectedLanguage || folder.translations.get(selectedLanguage) || creatingNew">
                <mat-error *ngIf="renameFolderError">
                    {{renameFolderError}}
                </mat-error>
                <mat-form-field class="full-width-input">
                    <input matInput type="text"
                        placeholder="{{ 'dialog.rename-folder.placeholder.folder-name' | translate }}"
                        formControlName="folderName" required>
                    <mat-error *ngIf="formSubmitAttempt">
                        {{ 'dialog.rename-folder.error.invalid-folder-name' | translate }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="full-width-input">
                    <textarea matInput type="text"
                        placeholder="{{ 'dialog.rename-folder.placeholder.folder-description' | translate }}"
                        formControlName="description"></textarea>
                    <mat-error *ngIf="formSubmitAttempt">
                        {{ 'dialog.rename-folder.error.invalid-folder-description' | translate }}
                    </mat-error>
                </mat-form-field>
                <div id="rename-folder-action-container">
                    <button type="button" id="rename-folder-button-remove" mat-button color="primary"
                        *ngIf="!edited() && selectedLanguage" (click)="deleteTranslation()">
                        {{ 'dialog.rename-folder.button.delete-translation' | translate | uppercase }}
                    </button>

                    <button type="button" id="rename-folder-button-cancel" mat-button
                        [disabled]="!edited() && !createNewTranslation" color="warn" *ngIf="edited()"
                        (click)="cancel()">
                        {{ 'general.button.cancel' | translate | uppercase }}
                    </button>
                    <button type="submit" id="rename-folder-button-submit" mat-button [disabled]="!edited()"
                        color="primary">
                        {{ 'general.button.save' | translate | uppercase }}
                    </button>
                </div>
            </form>


        </div>
    </div>
</div>